import { X } from "lucide-react";
import { Link } from "react-router-dom";

interface LegalDocumentProps {
  title: string;
  closeLabel: string;
  mode?: "modal" | "page";
  onClose?: () => void;
  children: React.ReactNode;
}

export function LegalDocument({
  title,
  closeLabel,
  mode = "page",
  onClose,
  children,
}: LegalDocumentProps) {
  const isModal = mode === "modal";

  return (
    <div className={isModal ? "fixed inset-0 bg-white z-[100] overflow-y-auto" : "bg-white"}>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className={`mb-8 ${isModal ? "flex items-center justify-between" : ""}`}>
          {!isModal && (
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#004f4f] hover:text-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] rounded-lg transition-colors mb-8 font-semibold"
            >
              Powrót do strony głównej
            </Link>
          )}
          <h1 className="text-4xl font-bold text-slate-900">{title}</h1>
          {isModal && onClose && (
            <button
              onClick={onClose}
              className="p-2 text-slate-600 hover:text-[#004f4f] focus:outline-none focus:ring-4 focus:ring-[#004f4f] rounded-lg transition-colors"
              aria-label={closeLabel}
            >
              <X size={32} />
            </button>
          )}
        </div>

        <div className="prose prose-slate max-w-none">{children}</div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          {isModal && onClose ? (
            <button
              onClick={onClose}
              className="bg-[#004f4f] text-white px-8 py-3 rounded-full hover:bg-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold"
            >
              Powrót do strony głównej
            </button>
          ) : (
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#004f4f] text-white px-8 py-3 rounded-full hover:bg-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold"
            >
              Powrót do strony głównej
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
